import createEnvConfig from './util/create-env-config';

export const ATLAS_V3_MIN_INSTALLER_VERSION = '1.6.7';

export default createEnvConfig({
  MAPBOX_API_ENDPOINT: {
    production: 'https://api.mapbox.com',
    staging: 'https://cloudfront-staging.tilestream.net'
  },
  MAPBOX_APP_ENDPOINT: {
    production: 'https://www.mapbox.com',
    staging: 'https://fastly-staging.tilestream.net'
  },
  MAPBOX_ATLAS_ENDPOINT: {
    production: 'https://atlas.mapbox.com',
    staging: 'https://atlas.tilestream.net'
  },
  MBXXHR_ORIGIN: {
    production: 'production',
    development: 'staging'
  },
  MAPBOX_ACCOUNT_URL_ORIGIN: {
    production: 'https://account.mapbox.com',
    staging: 'https://dev-account.tilestream.net'
  }
});
